module.exports = __webpack_public_path__ + "img/19.5183763c.jpg";